var process = (typeof require != "undefined") ? require("process") : false;
var exec = (typeof require != "undefined") ? require('child_process').exec : false;
var gui = (typeof require != "undefined") ? require('nw.gui') : false;

// Constructor
function Canola() {

  // Holder for game function
  this.game = false;

  // i18n object
  this.i18n = new i18n(this);

  // Audio wrapper
  this.audio = new AudioPlayer();

  // Screensaver wrapper
  this.screensaver = new Screensaver();

  // Screensaver
  this.resetDelay = 120000;
  // this.resetDelay = 3000000000;

  // Init buttons
  this.initButtons();

  // Get preset game name
  if (gui) {
    this.gameName = (gui.App.argv.length > 0) ? gui.App.argv[0] : null;
  } else {
    this.gameName = getURLParameter("game");
  }

  // Launch game if one is specified, otherwise show buttons
  if (this.gameName != false && jQuery.inArray(this.gameName, ["gmos", "farmer", "friendfoe"]) != -1) {
    this.launch(this.gameName)
    $("#triggers").remove();
  }

  // Timeout (screensaver) related
  $(document).on("click", $.proxy(function (e) {
    this.resetTimer();
  }, this));
  setInterval($.proxy(function () {
    this.checkTimer();
  }, this), 1000);

  // Guides toggle
  $("#guide").hide();
  $(window).bind("keydown", $.proxy(function (e) {
    // G key is presse
    if (e.keyCode == 71) {
      $("#guide, .guide").toggle();
    } else if (e.keyCode == 27) {
      // Escape
      if (gui) {
        gui.App.quit();
      }
    }
  }, this));

}

Canola.prototype.launch = function (gameName) {

  // Launch game if none has been lauched
  if (this.game == false) {
    if (gameName == "gmos") {
      // Launch data filters
      console.log("launching " + gameName);
      this.game = new GMOs(this);
      // $("#triggers").remove();
    } else if (gameName == "farmer") {
      // Launch my garden
      console.log("launching " + gameName);
      this.game = new Farmer(this);
      // $("#triggers").remove();
    } else if (gameName == "friendfoe") {
      // Launch my garden
      console.log("launching " + gameName);
      this.game = new FriendFoe(this);
      // $("#triggers").remove();
    } else {
      console.log("game " + gameName + " couldn't be launched.");
      return false;
    }
  }
}

Canola.prototype.start = function () {
  this.game.start();
};

Canola.prototype.initButtons = function () {

  // Init big buttons dynamic action
  $("#game").on("click", ".help, .trigger, .button, .box-close, .action", $.proxy(function (e) {
    var el = $(e.currentTarget);
    if (el.data("action") == "function") {
      var functionName = el.data("function")
      if(el.data("selection")) {
        console.log("calling function game." + functionName + "(" + el.data("selection") +")");
        this.game[functionName](el.data("selection"));
      } else {
        console.log("calling function game." + functionName + "()");
        this.game[functionName]();
      }
    } else if (el.data("action") == "launchgame") {
      this.launch($(e.target).data("gamename"));
    }
  }, this));

  // Init home action
  $("#game").on("click", ".home", $.proxy(function (e) {
    console.log("calling gotoHome()");
    this.reset();
  }, this));

};

Canola.prototype.resetTimer = function (data) {
  this.lastClick = millis();
}

Canola.prototype.checkTimer = function (data) {
  var noActionSince = millis() - this.lastClick;
  if (noActionSince > this.resetDelay) {
    this.reset();
  }
}

Canola.prototype.reset = function () {
  if (millis() - this.lastReset < 3000) {
    return;
  }

  this.lastClick = millis();
  this.lastReset = millis();
  this.game.reset();
};


Canola.prototype.closeModal = function (selector) {

  $(selector).addClass("hide");
  $("body").removeClass("modal-opened")

  $.event.trigger({
    type: "closeModal"
  });

  requestTimeout($.proxy(function (selector) {
    $(selector).addClass("hidden");
  }, this, selector), 700)
}

Canola.prototype.showModal = function (selector, addBlur) {

  addBlur = (typeof addBlur != "undefined") ? addBlur : true;

  $(selector).removeClass("hidden");
  $("body").addClass("modal-opened");
  $("body").toggleClass("modal-opened-noblur", (addBlur === false));

  requestTimeout($.proxy(function () {
    $(selector).removeClass("hide");
  }, this, selector), 50)
}

Canola.prototype.initSVG = function () {

  $('img.svg').each(function () {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgGraphicID = $img.data('graphic-id');
    var imgAnimationPathID = $img.data('animation-path-id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.ajax({
      url: imgURL,
      success: $.proxy(function ($img, imgID, imgGraphicID, imgAnimationPathID, imgClass, data) {
        // Get the SVG tag, ignore the rest
        var $svg = $("<div>" + data + "</div>").find('svg');
        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's graphic-id to the new SVG
        if (typeof imgGraphicID !== 'undefined') {
          $svg = $svg.attr('data-graphic-id', imgGraphicID);
        }
        // Add replaced image's animation-path-id to the new SVG
        if (typeof imgAnimationPathID !== 'undefined') {
          $svg = $svg.attr('data-animation-path-id', imgAnimationPathID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        // Remove any invalid XML tags as per http:validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');
        // Replace image with new SVG
        $img.replaceWith($svg);
      }, this, $img, imgID, imgGraphicID, imgAnimationPathID, imgClass),
      dataType: "text"
    });
  });
}

// Expose Canola
window.Canola = Canola;

